import { apiCall } from 'api';
import { getTokenUserAnonymous } from './anonymousLocalStoreUser';


export const getUserToken = () => {
  const tokenLocalStore = JSON.parse(localStorage.getItem('loginInfo.logged_user_data' || '{}'))?.token;

  return (
    apiCall?.defaults?.params?.user_token ||
    tokenLocalStore || 
    getTokenUserAnonymous()
  );
};
